import styled from '@emotion/styled'

import theme from '../styles/theme'
import { media } from '../styles/tools'

const ContentColumn = styled.div({
  [media.laptop]: { marginRight: theme.barWidth.laptop },
})

export default ContentColumn
